const OutdatedBrowser = () => {
  return null;
};

export default OutdatedBrowser;
